var _g, _g2;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFilterIconBlack = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 125",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#000000",
    cx: 50,
    cy: 50,
    r: 40
  }), /*#__PURE__*/React.createElement("circle", {
    display: "inline",
    fill: "#000000",
    cx: 50,
    cy: 50,
    r: 40
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.5,40.7c4.4,0,8.1-3,9.2-7h40.7v-5H38.7c-1.1-4-4.8-7-9.2-7c-5.2,0-9.5,4.3-9.5,9.5C20,36.5,24.3,40.7,29.5,40.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8,56.5c-4.4,0-8.1,3-9.2,7h-41v5h41c1.1,4,4.8,7,9.2,7c5.2,0,9.5-4.3,9.5-9.5S76,56.5,70.8,56.5z"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterIconBlack, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter_icon_black.48fbcc3a.svg";
export { ForwardRef as ReactComponent };